import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Section, Text } from "@react-email/components";
const footerStyle = {
    color: '#545454',
    textAlign: 'center'
};
const linkStyle = {
    color: '#000000'
};
export default function Footer() {
    return (_jsx(Section, { children: _jsxs(Text, { style: footerStyle, children: ["Powered by ", _jsx(Link, { href: 'https://braidpay.com', style: linkStyle, children: "BraidPay" })] }) }));
}
